import { render } from "./historyTransaction.vue?vue&type=template&id=6dc4d20c"
import script from "./historyTransaction.vue?vue&type=script&lang=js"
export * from "./historyTransaction.vue?vue&type=script&lang=js"

import "./historyTransaction.vue?vue&type=style&index=0&id=6dc4d20c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__